package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_05_12_Day_1
import com.veldekar.components.logs.Log_2023_05_12_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-05-12")
@Composable
public fun Log_2023_05_12(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Mission to Malus",
        ogTitle = "Mission to Malus",
        date = LocalDate(2_023, 5, 12),
        ogDescription = "Tuesday acquires a magical cloak, and the party is tasked by the Peers to secure the shield shard in Malus.",
        ogImage = "ai/2023-05-12.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-24", dateString = "Newgrowth 24")
        Log_2023_05_12_Day_1()
        SessionDayHeader(dayId = "newgrowth-25", dateString = "Newgrowth 25")
        Log_2023_05_12_Day_2()
    }
}
